<template>
  <div>

    <section-definition :title="page.title" :extraOptions="page.options" :icon="page.icon"
      :exportOptions="page.exportOptions" :breadcrumbs="page.breadcrumbs" @openFilter="openRecordingReportFilter"
      @refreshPage="refreshRecordingReportPage" @exportData="exportRecordingReport" @checkboxsend="checkboxclick"
      :showTranscription="selectedItems.length > 0" :style="styleObject"></section-definition>
    <loader v-if="page.loading"></loader>


    <v-container v-else fluid grid-list-xl page>


      <v-data-table :headers="headers" :items="recording_dates" class="elevation-1" :pagination.sync="pagination"
        :total-items="recordingtotal" :rows-per-page-items="[5, 10, 25]" :key="tableKey">
        <!-- Custom header slot -->
        <template v-slot:headers="props">
          <tr>
            <!-- Checkbox for selecting all rows -->
            <th v-if="showcheckbox === true">
              <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" class="checkbox" />
            </th>
            <!-- Other header columns -->
            <th v-for="header in props.headers" :key="header.text">
              {{ header.text }}
            </th>
          </tr>
        </template>
        <!-- Custom items slot -->
        <template v-slot:items="props">
          <tr>
            <!-- Row-specific checkbox -->
            <td v-if="showcheckbox === true">
              <input type="checkbox" v-model="selectedItems" :value="props.item" class="checkbox" />
            </td>
            <!-- Row data -->
            <td class="checkEmpty p0" v-for="(property, index) in Object.keys(props.item)" :key="index">
              {{ headers[index].value === property && headers[index].masking ? ChartoMaskingChar(props.item[property]) :
                props.item[property] }}
            </td>

            <!-- Action buttons based on status -->
            <td class="text-xs-center checkEmpty">
              <div class="row">
                <v-btn small fab flat color="info" @click="editItem(props.item)">
                  <i class="fa fa-comments" aria-hidden="true"></i>
                </v-btn>

                <!-- Toggle Listen -->
                <v-btn small fab flat color="info" @click="togglePlayingRecordSheet('Listen', props.item)">
                  <i class="fas fa-microphone"></i>
                </v-btn>

                <!-- Buttons rendered based on status -->
                <div v-for="(output) in analytics_output" :key="output.uid">
                  <template v-if="props.item.Uniqueid === output.uid">

                    <!-- Not Processed Button -->
                    <!-- <v-btn v-if=" this.recordingplay !== '' && output.status === 'notstarted'" small fab flat
                      color="info" @click="insertDetails(props.item)" :disabled="true">
                      <img src="@/assets/icons/graphic_eq 1.png" />
                    </v-btn> -->
                    <v-btn v-if="output.status === 'notstarted'" small fab flat color="info"
                      @click="insertDetails(props.item)">
                      <img src="@/assets/icons/graphic_eq 1.png" />
                    </v-btn>

                    <!-- Completed Button -->
                    <v-btn v-if="output.status === 'completed'" small fab flat color="info"
                      @click="showsentiment(props.item)">
                      <img src="@/assets/icons/Analytic_process_green.svg" />
                    </v-btn>

                    <!-- Download Progress Button -->
                    <v-btn v-if="output.status === 'inprogress'" small fab flat color="info">
                      <div class="page">
                        <div class="downloading">
                          <span class="custom-arrow"></span>
                        </div>
                        <div class="bar"></div>
                      </div>
                    </v-btn>
                  </template>
                </div>
              </div>
            </td>
          </tr>
        </template>

      </v-data-table>

    </v-container>

    <v-navigation-drawer fixed disable-resize-watcher right v-model="page.isFilterOpen" class="filterNavigation">

      <v-toolbar small color="secondary" style="color: white">
        <v-toolbar-title>Filter</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon flat color="white" @click="page.isFilterOpen = false">
          <i class="fas fa-close"></i>
        </v-btn>
      </v-toolbar>
      <div class="flex-column justify-sb height-100-exclude-toolbar overflow-auto">
        <v-container class="sidenavContainer">
          <RecordingReportFilter v-if="page.isFilterOpen" @getDataFrom="getDataFrom" :appliedfilter="appliedfilter"
            :teambool="teambool" :teamvalues="teamvalues">
          </RecordingReportFilter>
        </v-container>
        <v-container row class="sidenavFooter">
          <v-btn flat @click="resetvalue()">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="FilterData">Filter</v-btn>
        </v-container>
      </div>
    </v-navigation-drawer>
    <v-bottom-sheet v-model="page.playingRecord" hide-overlay persistent lazy inset max-width="500" class="align-left"
      id="barging-div" transparent>
      <v-card tile class="player-div">
        <v-toolbar color="light" small>
          <audio controls autoplay v-if="page.playingRecord">
            <source :src="recordingplay" type="" />
            <img src="kksdkk">
            Your browser does not support the audio element.
          </audio>
          <v-spacer></v-spacer>
          <div class="row justify-fe">
            <v-btn icon>
              <v-icon @click="togglePlayingRecordSheet('close', {})">close</v-icon>
            </v-btn>
          </div>
        </v-toolbar>
      </v-card>
    </v-bottom-sheet>
    <template>
      <v-dialog persistent :value="isopen" scrollable max-width="500px">
        <v-card>
          <v-toolbar dark color="primary" class="modal-header--sticky">
            <v-card-title>
              <span class="headline">Add Comments</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="RecordingreportMain" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="Comments" required label="Comments" type="text"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="modal-footer--sticky">
            <v-spacer></v-spacer>
            <v-btn color="light" flat @click="closecomments()">Close</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="save()">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="groups.save.active" max-width="500px">
        <v-card>
          <v-toolbar dark color="primary">
            <v-card-title>
              <span class="headline">Transcription Status</span>
            </v-card-title>
          </v-toolbar>

          <v-card-text style="max-height: 500px; overflow-y: auto;">
            <!-- Already Processed Section -->
            <v-card-subtitle><strong>Already Processed</strong></v-card-subtitle>
            <v-list dense style="padding-top: 10px; line-height: 34px;">
              <template v-if="alreadyProcessedDetails.length === 0">
                ---/---/---
              </template>
              <template v-else>
                <v-list>
                  <v-list-item v-for="(item, index) in alreadyProcessedDetails" :key="item.uniqueid">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ index + 1 }}. Audio {{ (index + 1).toString().padStart(2, '0') }} :
                        <a href="#"  @click.prevent="showsentiment(item)" style="border-bottom: 1px solid black;">{{ item.uniqueid }}</a>
                        <br>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>


            </v-list>
            <!--Inprogress-->
            <v-card-subtitle><strong>In Progress</strong></v-card-subtitle>
            <v-list dense style="padding-top: 10px; line-height: 34px;">
              <template v-if="InprogressDetails.length == 0">
                ---/---/---
              </template>
              <template v-else>
                <v-list-item v-for="(item, index) in InprogressDetails" :key="item.uniqueid">
                  <v-list-item-content>
                    <v-list-item-title>

                      {{ index + 1 }}. Audio {{ (index + 1).toString().padStart(2, '0') }} :
                      <a :href="item.url" target="_blank" style="border-bottom: 1px solid black;">{{ item.uniqueid }}</a><br>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

            </v-list>

            <!-- Audio Process -->
            <v-card-subtitle><strong>Audio Not Ready</strong></v-card-subtitle>
            <v-list dense style="padding-top: 10px; line-height: 34px;">
              <template v-if="audioNotReadyDetails.length === 0">
                ---/---/---
              </template>
              <template v-else>
                <v-list-item v-for="(item, index) in audioNotReadyDetails" :key="item.uniqueid">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ index + 1 }}. Audio {{ (index + 1).toString().padStart(2, '0') }} :
                      <span style="border-bottom: 1px solid black;">{{ item.uniqueid }}</span><br>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

            </v-list>


            <!-- Process Initiated Section -->
            <!-- <v-card-subtitle><strong> Process Initiated</strong></v-card-subtitle>
            <v-list dense style="padding-top: 20px;">
              <v-list-item v-for="item in startingProcessDetails" :key="item.uniqueid">
                <v-list-item-content>
                  <v-list-item-title>
                    Unique ID: {{ item.uniqueid }}
                    URL:<a :href="item.url" target="_blank">Link</a>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list> -->
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="groups.save.active = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar.show" :right="true" :bottom="true" :color="'red'" :timeout="snackbar.timeout">
        {{ snackbar.text }}
        <v-btn color="black" flat @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </template>
  </div>
</template>
<script>
import loader from "@/components/Widgets/loader";
// import axios from "axios";
import RecordingReportFilter from "./Components/RecordingReportFilter";
import { MaskCharacter } from "@/utils/helpers";
import { mapGetters } from "vuex";
import moment from "moment";
// import { error } from "console";

export default {

  components: {
    loader,
    RecordingReportFilter,
    // pdfexport,
  },
  mounted() {
    let scope = this;
    this.page.loading = false;
    let data = JSON.parse(localStorage.getItem("call_transcription"));
    if (data != null && data.call_transcription === true) {
      console.log("showwww");
      this.showcheckbox = true;
      this.fetchAndUpdateStatus();
      this.interavelid = setInterval(this.fetchAndUpdateStatus, 5000); // Update every 5 seconds
    }
    // this.$store.dispatch("reportuserlist").then(() => {
    // // this.getDataFromApi();
    // this.dateformate();
    // });
    let teams = JSON.parse(localStorage.getItem("Team"))
    let team_agent_user = JSON.parse(localStorage.getItem("Team_agent_user"))
    if (teams.length > 0 && team_agent_user.length > 0) {
      this.teambool = true
      this.teamvalues = team_agent_user
    } else {
      this.teambool = false
      this.teamvalues = []
    }
    this.dateformate();
    // this.token = this.auth0accessToken;
    setTimeout(
      function () {
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "reports:recording:export"
          ) !== -1
        ) {
          scope.page.exportOptions = ["CSV", "Txt(Tab-Delimited)"];
        } else {
          scope.page.exportOptions = [];
        }
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:masking:invisible"
          ) === -1
        ) {
          scope.masking = true;
        }
      }.bind(scope),
      1
    );
    this.getDataFromApi();
  },

  computed: {
    ...mapGetters(["recording_date", "auth0accessToken", "MaskingModules"]),
    ...mapGetters(["recording_date", "auth0accessToken", "MaskingModules"]),

    flags() {
      const inProgress = this.flagValues.inProgress || [];
      const completed = this.flagValues.completed || [];
      const notProcessed = this.flagValues.notProcessed || [];
      return { inProgress, completed, notProcessed };
    },
    selectAll: {
      get() {
        return this.selectedItems.length === this.recording_dates.length;
      },
      set(value) {
        this.selectedItems = value ? [...this.recording_dates] : [];
      },
    },
  },
  data() {
    return {
      showcheckbox: false,
      summaries: [],
      groups: {
        save: {
          active: false,
          data: '',
        }
      },
      audioNotReadyDetails: '',
      // startingProcessDetails: '',
      alreadyProcessedDetails: '',
      InprogressDetails: '',
      snackbar: {
        show: false,
        timeout: 5000,
        text: "",
      },
      records: [], // Initialize as an empty array
      interavelid: null,
      analytics_output: [],
      flagValues: { inProgress: [], completed: [], notProcessed: [] },
      buttonState: null, // Tracks the current button state
      uniqueid: "", // Replace with actual ID logic
      buttonText: "Check", // Default button text
      buttonIcon: "@/assets/icons/graphic_eq 1.png", // Default button icon
      buttonColor: "info", // Default button color
      flag: null,
      selectedItems: [],
      styleObject: {
        height: "80px",
        "margin-top": "-8px",
      },
      page: {
        title: "Call Recordings Report",
        icon: "fa-compact-disc fa-2x",
        loading: true,
        isFilterOpen: false,
        playingRecord: false,
        breadcrumbs: [],
        exportOptions: [],
        options: { filter: true, refresh: true, transcription: true },
      },
      payload: {
        form_date: "",
        to_date: "",
        skip: 0,
        take: 0,
        agent: "",
        calltrans: "",
        descending: "",
        export: "exportrecordigdetails",
      },
      apiinfo: JSON.parse(localStorage.apiInfo || "{}"),
      appliedfilter: {
        operator: "",
        value: "",
        phonenumber: "",
        type: "",
        station: "",
        agent: "",
        calltrans: "",
        did: "",
        queue: "",
        dispo: "",
        status: "",
        flag: false,
        f_flag: 0,
        t_flag: 0,
        uniqueid: "",
        subdispo: ""
      },

      url: "",
      dialog: false,
      recordingplay: "",
      pagination: {
        rowsPerPage: 10,
      },
      local_token: "",
      headers: [

        { text: "Play", align: "left", sortable: true, class: "p0", value: "" },
      ],

      recordingreport: [],
      tableKey: 0, // Unique key for the table
      recording_dates: [],
      recordingtotal: 0,
      txt_data: [],
      excel_data: [],
      page_flag: false,
      pages: "",
      isopen: false,
      Comments: "",
      dispoList: [],
      subdispoList: [],
      Filename: "RecordingReport",
      masking: false,
      teambool: false,
      teamvalues: []
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  methods: {
    showSnackBar(message) {
      this.snackbar.text = message;
      this.snackbar.show = true;
      setTimeout(() => {
        this.snackbar.text = "";
        this.snackbar.show = false;
      }, this.snackbar.timeout);
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedItems = [...this.recording_dates];

      } else {
        this.selectedItems = [];
      }
    },
    async fetchAndUpdateStatus() {
      try {
        const uniqueIds = this.recording_dates.map(record => record.Uniqueid);
        const response = await this.$store.dispatch("CallTranscriptionfetch", { uniqueids: uniqueIds });
        if (this.showcheckbox === true) {
          let responseData = response.data.data || [];
          this.summaries = responseData.reduce((acc, item) => {
            acc[item.uniqueid] = item.summary !== undefined ? item.summary : "Not transcript";
            return acc;
          }, {});
          console.log(responseData, response.status, "Transformed API response", this.summaries);
        }
        if (response.data.data && Array.isArray(response.data.data)) {
          this.analytics_output = response.data.data.map(item => ({
            uid: item.uniqueid,
            status: item.status,
          }));

          console.log(this.analytics_output, "Transformed API response");
        } else {
          console.error("Unexpected API response structure");
        }
      } catch (error) {
        console.error("Error fetching transcription status:", error);
      }
    },


    async insertDetails(records) {
      try {
        if (!Array.isArray(records)) {
          if (records && typeof records === "object") {
            records = [records];
          } else {
            console.error("Expected 'records' to be an array or object.");
          }
        }
        const transcriptionPayloads = [];
        records.forEach(record => {
          const payload = {
            uniqueid: record.Uniqueid,
            user: record.Agent || "Unknown",
          };
          transcriptionPayloads.push(payload);
        });
        const transcriptionResponse = await this.$store.dispatch("CallTranscription", transcriptionPayloads);
        const data = transcriptionResponse.data.data
        console.log(data, "eigcuuuuuuuuuyge");

        let extractedValues = data.map(item => ({
          isaudio: item.isaudio,
          isduplicate: item.isduplicate,
          isInprogress: item.isInprogress,
          uniqueid: item.uniqueid,
          url: item.url,
          calldate: item.calldate
        }));
        let audioNotReadyData = extractedValues.filter(item => item.isaudio === false && item.isduplicate === false && item.isInprogress === false);
        // let startingProcessData = extractedValues.filter(item => item.isaudio === true && item.isduplicate === false && item.isInprogress === false);
        let InprogressData = extractedValues.filter(item => item.isaudio === true  && (item.isInprogress === true|| item.isduplicate === false) );
        let alreadyProcessedData = extractedValues.filter(item => item.isaudio === true && item.isduplicate === true && item.isInprogress === false);

        console.log(transcriptionResponse, "Transcription Payloads:", extractedValues);
        this.selectedItems = [];
        this.selectAll = false;
        if (data.length === 1) {
          if (audioNotReadyData.length > 0) {
            this.showSnackBar("Audio is Not Ready!");
          }
        }
        else {

          this.groups.save.data = {
            audioNotReady: audioNotReadyData,
            alreadyProcessed: alreadyProcessedData,
            // startingProcess: startingProcessData,
            Inprogress: InprogressData
          };

          if (audioNotReadyData.length > 0 || alreadyProcessedData.length > 0) {
            this.groups.save.active = true;  // Open the popup
            // Extract uniqueid and url for audioNotReady
            this.audioNotReadyDetails = this.groups.save.data.audioNotReady.map(item => ({
              uniqueid: item.uniqueid,
              url: item.url
            }));

            // Extract uniqueid and url for alreadyProcessed
            this.alreadyProcessedDetails = this.groups.save.data.alreadyProcessed.map(item => ({
              uniqueid: item.uniqueid,
              url: item.url,
              calldate: item.calldate
            }));

            // Extract uniqueid and url for startingProcess
            // this.startingProcessDetails = this.groups.save.data.startingProcess.map(item => ({
            //   uniqueid: item.uniqueid,
            //   url: item.url
            // }));

            this.InprogressDetails = this.groups.save.data.Inprogress.map(item => ({
              uniqueid: item.uniqueid,
              url: item.url
            }));
            console.log("Popup Data:", this.groups.save.data);
          }
        }
      } catch (error) {
        console.error("Error inserting details:", error);
      }
    },


    async checkboxclick(selectedItems) {
      const items = selectedItems || this.selectedItems;
      console.log("Selected Items:", items);
      try {
        await this.insertDetails(items);
        console.log("Data successfully inserted.");
        this.selectedItems = [];
        this.selectAll = false;
      } catch (error) {
        console.error("Error in checkboxclick:", error);
      }
    },

    showsentiment(item) {
      let uniqueIds
      let date
      // let urls
      if (!item.Uniqueid) {
        uniqueIds = item.uniqueid;
        date = moment(item.calldate).format("YYYY-MM-DD")
        console.log(item, "ask iurg");
      }
      else {
        uniqueIds = item.Uniqueid
        date = moment(item.CallDate).format("YYYY-MM-DD")
      }

      console.log(uniqueIds, "savt uieytwqe");

      console.log(uniqueIds, "gdibevuuuuuuuuuuuuuuuuu", date);
      this.$router.push({
        path: "/sentimentanalys",
        query: { uniqueid: uniqueIds, date: date }
      });
    },

    FilterData() {
      this.page.isFilterOpen = false
      this.getDataFromApi()
    },
    closeModel: function () {
      this.dialog = false;
    },
    openRecordingReportFilter: function () {
      this.page.isFilterOpen = true;
    },
    refreshRecordingReportPage: function () {
      var scope = this;
      scope.appliedfilter.operator = "";
      scope.appliedfilter.value = "";

      // this.pagination.page = 1
      scope.dateformate();
      scope.page.loading = true;
      this.refreshvalue();
      this.appliedfilter.phonenumber = "";
      this.appliedfilter.type = "";
      this.appliedfilter.station = "";
      this.appliedfilter.agent = "";
      this.appliedfilter.calltrans = "";
      this.appliedfilter.did = "";
      this.appliedfilter.queue = "";
      this.appliedfilter.dispo = "";
      this.appliedfilter.status = "";
      this.appliedfilter.uniqueid = "";
      this.appliedfilter.subdispo = "";
      scope.getDataFromApi();
    },
    exportRecordingReport: function (option) {
      if (option == "CSV" || option == "Txt(Tab-Delimited)") {
        this.export(option);
      } else {
        this.dialog = true;
        this.export(option);
        // this.pdf_flag = true;
      }
    },
    togglePlayingRecordSheet: function (event, item) {
      if (event == "close") {
        this.page.playingRecord = false;
      } else {
        var date = moment(item.CallDate).format("YYYY-MM-DD");
        // var decoded = jwtDecode(this.token);
        // var tid = decoded["http://api.doocti.com/claims/tenant_code"];
        var items = {
          id: item.Uniqueid,
          date: date,
          tid: this.apiinfo.tenant_code,
        };
        console.log(item, "itemitemitemitem", items, date)
        return new Promise(() => {
          this.$store.dispatch("audioplay", items).then((response) => {
            this.recordingplay = response.url;
            if (response.isAudio === false) {
              this.showSnackBar("Audio is Not Ready!");
            }
            if (this.recordingplay != "" && response.isAudio === true) {
              this.page.playingRecord = true;
            }
          });
        });
      }
    },
    dateformate() {
      this.page.loading = false;
      this.to_date = new Date();
      this.to_date = moment(this.to_date).format("YYYY-MM-DD HH:mm:ss");
      var from_date1 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 1;
      from_date1.setTime(from_date1.getTime() - dateOffset);
      this.from_date = moment(from_date1).format("YYYY-MM-DD HH:mm:ss");
      this.$store.commit("FILTERFROMDATE", this.from_date);
      this.$store.commit("FILTER_TODATE", this.to_date);
      // this.getDataFrom();
    },
    getDataFromApi() {
      var scope = this;
      this.payload.value = this.appliedfilter.value
      this.payload.operator = this.appliedfilter.operator
      this.payload.dispo = this.appliedfilter.dispo
      this.payload.subdispo = this.appliedfilter.subdispo
      var to_date = new Date();
      this.payload.to_date = moment(to_date).format("YYYY-MM-DD HH:mm:ss");
      var from_date1 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 30;
      from_date1.setTime(from_date1.getTime() - dateOffset);
      this.payload.from_date = moment(from_date1).format("YYYY-MM-DD HH:mm:ss");
      var { page, rowsPerPage } = this.pagination;
      this.payload.take = rowsPerPage;
      //scope.$store
      // .dispatch("reportuserlist")
      // .then((response) => {
      let dataa = []
      let team_name = ""
      let teams = JSON.parse(localStorage.getItem("Team"))
      let team_agent_user = JSON.parse(localStorage.getItem("Team_agent_user"))
      if (teams.length > 0 && team_agent_user.length > 0) {
        dataa = team_agent_user
        dataa = team_agent_user
        team_name = teams.map(elm => elm.name).flat()
      }
      else {
        dataa = JSON.parse(localStorage.getItem("agent_emails"));
      }

      scope.payload.agent = dataa;
      scope.payload.calltrans = (this.appliedfilter.calltrans || [])
        .filter(val => ["Not started", "In progress", "Completed"].includes(val))
        .join(",");
      if (rowsPerPage == undefined) {
        rowsPerPage = 5;
      }
      if (rowsPerPage == -1) {
        this.payload.take = this.total;
      } else {
        this.payload.take = rowsPerPage;
      }
      if (page != "" && page != undefined && page != null) {
        this.skip = page;
      } else {
        this.skip = 1;
      }
      this.payload.skip = (this.skip - 1) * this.payload.take;
      return new Promise((resolve) => {
        var { descending } = scope.pagination;
        this.payload.descending = descending;
        this.payload.team_name = team_name
        this.payload.team_agent_user = team_agent_user
        this.$store
          .dispatch("recordingdetails", this.payload)
          .then((response) => {
            var datas = response.data;
            console.log(datas, "urldata");

            scope.recording_dates = datas;
            let values = scope.recording_dates
            for (let i = 0; i < values.length; i++) {
              let element = values[i]
              delete element.record_location
              delete element.queue
              delete element.queue_enter_time
              delete element.status
              delete element.answer_time
              delete element.last_app
              delete element.comments
              delete element.dispo_status
              delete element.did_number
            }


            scope.page.loading = false;
            if (response.data.length) {
              scope.headers = [];
              Object.keys(response.data[0]).forEach((element) => {
                scope.headers.push({
                  text: element,
                  align: "left",
                  sortable: false,
                  class: "p0",
                  value: element,
                  masking: scope.masking && element == this.MaskingModules.MaskingModules[this.Filename].find(elm => elm == element)
                  // text1:"play"
                });

              });
            }
            this.total = response.count;
            this.recordingtotal = this.total;
            resolve(this.total);
            if (response.response.status === 401) {
              scope.$store.dispatch("checkingtoken");
            }

            this.$store.dispatch("reportDispo").then(() => {
              this.$store.dispatch("reportSubdispo").catch(() => {
                this.$store.dispatch("reportDispo").then(() => {
                  this.$store.dispatch("reportSubdispo").catch((err) => {
                    console.log(err)
                  })
                }).catch((err) => {
                  console.log(err)
                })
              }).catch((err) => {
                console.log(err)
              })
            })
              .catch(function (err) {
                if (err.response.status === 401) {
                  scope.$store.dispatch("checkingtoken");
                }
              });
          });
      })
        .catch(() => {

        });
    },
    getDataFrom() {
      this.skip = 0;
      this.getDataFromApi();
      this.page_flag = true;
      this.page.isFilterOpen = false
    },

    resetvalue() {
      // var to_date = new Date();
      // to_date = moment(to_date).format();
      // var from_date = new Date();
      // var dateOffset = 24 * 60 * 60 * 1000 * 30;
      // from_date.setTime(from_date.getTime() - dateOffset);
      // from_date = moment(from_date).format();
      this.refreshvalue();
      // this.$store.dispatch("fromdate", from_date);
      // this.$store.dispatch("todate", to_date);
      this.appliedfilter.uniqueid = "";
      this.appliedfilter.phonenumber = "";
      this.appliedfilter.type = "";
      this.appliedfilter.station = "";
      this.appliedfilter.agent = "";
      this.appliedfilter.calltrans = "";
      this.appliedfilter.did = "";
      this.appliedfilter.queue = "";
      this.appliedfilter.dispo = "";
      this.appliedfilter.status = "";
      this.appliedfilter.flag = true;
      this.appliedfilter.fromdate = "";
      this.appliedfilter.todate = "";
      this.appliedfilter.campaign = "";
      if (this.appliedfilter.flag) {
        // this.appliedfilter.fromdate = from_date;
        // this.appliedfilter.todate = to_date;
        // this.appliedfilter.flag = false;
        this.dateformate();
      }
      this.appliedfilter.subdispo = "";
      this.getDataFromApi();
      this.page.isFilterOpen = true;
    },
    export(option) {
      this.excel_data = [];
      this.txt_data = [];
      // this.pdf_data = [];
      let teams = JSON.parse(localStorage.getItem("Team"))
      // let team_agent_user =  JSON.parse(localStorage.getItem("Team_agent_user"))
      let team_name = ""
      if (teams.length > 0) {
        team_name = teams.map(elm => elm.name).flat()
        team_name = teams.map(elm => elm.name).flat()
      }

      var export_date = {
        from_date: this.payload.from_date,
        to_date: this.payload.to_date,
        calldetail: "exportrecordigdetails",
        team_name: team_name
      };
      this.$store.dispatch("exportdatafetch", export_date).then((response) => {
        this.exports = response;
        var phone;
        for (var i = 0; i < this.exports.length; i++) {
          if (this.masking) {
            this.MaskingModules.MaskingModules[this.Filename].forEach((elm) => {
              response[i][elm] = this.ChartoMaskingChar(response[i][elm])
            })
          }

          if (response[i]['Phone Number']) {
            var mobile_number = response[i]['Phone Number'];
            var reg = new RegExp("[&/\\#,+()$~%.'\":*?<>{}]", "gi");
            var phone_number = mobile_number.replace(reg, "");
            phone = phone_number.replace(" ", "");
          }
          if (response[i].CallDate) {
            var date = new Date(response[i].CallDate);
            var options = {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            };
            var timeString = date.toLocaleString("en-US", options);
            this.call_date = response[i].CallDate.substr(0, 11) + timeString;
          }
          let uniqueId = String(response[i].Uniqueid).trim();
          let summary
          if (this.showcheckbox == true) {
            summary = this.summaries[uniqueId] !== undefined ? this.summaries[uniqueId] : "Not transcript";
          }
          let rowData = {
            Date: this.call_date,
            uniqueid: response[i].Uniqueid,
            Phone: phone,
            Campaign: response[i].Campaign,
            Call_Type: response[i]['Call Type'],
            Agent: response[i].Agent,
            agentName: response[i]['Agent Name'],
            team: response[i].Team,
            Station: response[i].Station,
            Duration: response[i].Duration,
            Talk_Time: response[i]['Talk Time'],
            Recording_Path: response[i].record_location,
            summaries: summary,
          };
          if (this.showcheckbox) {
            rowData.summaries = summary;
          }
          this.excel_data.push(rowData);
          let txtRow = [
            this.call_date,
            response[i]['Uniqueid'],
            phone,
            response[i]['Campaign'],
            response[i]['Call Type'],
            response[i]['Agent'],
            response[i]['Agent Name'], // Fixed the typo from 'Agent Nmae'
            response[i].Team,
            response[i].Station,
            response[i].Duration,
            response[i]['Talk Time'],
            response[i].record_location
          ];

          // Add summary only if 'showcheckbox' is true
          if (this.showcheckbox) {
            summary = this.summaries[uniqueId] !== undefined ? this.summaries[uniqueId] : "Not transcript";
            txtRow.push(summary); // Push summary value as the last element
          }

          this.txt_data.push(txtRow); // Correctly push the modified txtRow array
          // this.pdf_data.push([
          // this.call_date,
          // response[i].uniqueid,
          // phone,
          // response[i].campaign,
          // response[i].call_type,
          // response[i].agent,
          // response[i].station,
          // response[i].duration,
          // response[i].talk_times,
          // response[i].record_location,
          // ]);
        }

        if (option == "Txt(Tab-Delimited)") {
          let txtContent = "";
          let txt_key = [
            "Date Time",
            "Uniqueid",
            "Phone Number",
            "Campaign",
            "Call Type",
            "Agent", "Agent Name", "Team",
            "Station",
            "Duration",
            "Talk Time",
            "Recording_Path",
            // "summaries"
          ];
          if (this.showcheckbox === true) {
            txt_key.push("summaries")
          }
          let txt_tab = txt_key.join("\t");
          txtContent += `${txt_tab} \r\n`;
          // csvContent += "Date,Uniqueid,DID,Queue,Phone Number,Call type ,Queue Enter Time ,Answer Time ,Application ,Agent ,Station,Dispo Status,Status ,Duration ,Talk Time,Comments \r\n";
          this.txt_data.forEach(function (rows) {
            let data = Object.values(rows);
            let row = data.join("\t");
            txtContent += row + "\r\n";
          });
          var date1 = new Date();
          date1 = moment(date1).format("YYYY-MM-DD hh-mm");
          var encodedUri1 =
            "data:text/plain;charset=utf-8,\uFEFF" +
            encodeURIComponent(txtContent);
          var link1 = document.createElement("a");
          link1.setAttribute("href", encodedUri1);
          link1.setAttribute("download", "RecordDetails" + date1 + ".txt");
          document.body.appendChild(link1);
          link1.click();
        }
        if (option == "CSV") {
          //var BOM = "\uFEFF";
          let csvContent = ""
          let csvkey = ["Date Time", "Uniqueid", "Phone Number", "Campaign", "Call Type", "Agent", "Agent Name", "Team", "Station", "Duration", "Talk Time", "Recording_Path"];
          // csvContent +=
          //   "Date Time,Uniqueid,Phone Number,Campaign,Call Type,Agent,Agent Name,Team,Station,Duration,Talk Time,Recording_Path,\r\n";
          if (this.showcheckbox === true) {
            csvkey.push("summaries")
          }
          let txt_tab = csvkey.join(",");
          csvContent += `${txt_tab} \r\n`;
          this.excel_data.forEach(function (rows) {
            var data = Object.values(rows);
            let data1 = [];
            data.forEach((elm) => {
              if (typeof elm === "string") {
                data1.push(elm.replace(/'|"|#|\n/g, " "));
              } else {
                data1.push(elm);
              }
            });
            for (let i = 0; i < data1.length; i++) {
              if (
                data1[i] != null &&
                data1[i] != undefined &&
                data1[i] != "" && typeof data1[i] == "string"
              ) {
                if (data1[i].includes(",")) {
                  data1[i] = `"${data1[i]}"`
                }
              }
            }
            let row = data1.join(",");
            csvContent += row + "\r\n";
          });
          var date11 = new Date();
          date11 = moment(date11).format("YYYY-MM-DD hh-mm");
          const encodedUri =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
          const link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "RecordDetails" + date11 + ".csv");
          document.body.appendChild(link); // Required for FF
          link.click();
        }
      });
    },


    refreshvalue() {
      this.$store.commit("FILTER_AGENT", { agent: "" });
      this.$store.commit("CALL_TRANSCRIPTION", { calltrans: "" });
      this.$store.commit("FILTER_TYPE", { type: "" });
      this.$store.commit("FILTER_STATION", { station: "" });
      this.$store.commit("FILTER_QUEUE", { queue: "" });
      this.$store.commit("FILTER_PHONE", { phone: "" });
      this.$store.commit("FILTER_CAMPAIGN", { campaign: "" });
      this.$store.commit("FILTER_UNIQUEID", { uniqueid: "" });
    },
    editItem: function (data) {
      this.Comments = data.Comments
      this.uniqueid = data.Uniqueid
      this.isopen = true
    },
    closecomments: function () {
      this.Comments = ""
      this.isopen = false
      this.getDataFromApi();
    },
    save: function () {
      console.log()
      if (this.Comments !== "") {
        this.$store
          .dispatch("recordingreportscomments", {
            comments: this.Comments,
            uniqueid: this.uniqueid

          })
          .then((response) => {
            console.log(response)
            this.closecomments()

          }).catch((err) => {
            console.log(err)
          })
      }
    },
    ChartoMaskingChar(data) {
      let scope = this
      if (!scope.$store.getters.MaskType.includes(typeof (data))) {
        return data
      }
      return MaskCharacter(data)
    }
  },

  beforeDestroy() {
    clearInterval(this.interavelid)
    this.$store.commit("FILTER_AGENT", { agent: "" });
    this.$store.commit("CALL_TRANSCRIPTION", { calltrans: "" });
    this.$store.commit("FILTER_TYPE", { type: "" });
    this.$store.commit("FILTER_STATION", { station: "" });
    this.$store.commit("FILTER_QUEUE", { queue: "" });
    this.$store.commit("FILTER_PHONE", { phone: "" });
    this.$store.commit("FILTER_CAMPAIGN", { campaign: "" });
    this.$store.commit("FILTER_UNIQUEID", { uniqueid: "" });
  },
};
</script>
<style>
.icons {
  height: 80px;
}

.graphic {
  box-shadow: transparent !important;


}

/* .v-datatable .v-input--selection-controls {
  position: absolute;
  left: 28px;
} */


/* .graphic:hover{
  background-color: #42a5f5;
  
  width: 20px;
    height: 20px;
    margin-top: 16px;
    border-radius: 50%;
    color: #f2ecec
} */
.checkbox {
  width: 20px;
  height: 20px;
}




/* .page {
  height: 100%;
  @include display-flex;
  @include align-items(center);
  -moz-box-align: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
} */

/* .folder {
  background-color: #2196f3;
  position: relative;
  width: 92px;
  height: 64px;
  display: block;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
} */
/* .folder-tab {
    position: absolute;
    height: 10px;
    left: 0;
    bottom: 100%;
    display: block;
    width: 40%;
    border-top-left-radius: 8px;
    background-color: inherit;
    &:after {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      left: calc(100% - 10px);
      border-bottom: 10px solid #2196f3;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
    }
  } */

/* .folder-icn {
    padding-top: 12px;
    width: 100%;
    height: 100%;
    display: block;
  } */
.downloading {
  width: 18px;
  /* Adjusted width */
  height: 20px;
  /* Adjusted height */
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  margin-left: 3px;
}

.custom-arrow {
  width: 6px;
  /* Adjusted width (half of the new downloading width) */
  height: 6px;
  /* Adjusted height (half of the new downloading height) */
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -4.5px;
  /* Adjusted margin to center */
  background-color: #2196f3;


  animation-name: downloading;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
}

.custom-arrow:after {
  content: '';
  position: absolute;
  display: block;
  top: 100%;
  left: -5px;
  /* Adjusted position */
  border-top: 8px solid #2196f3;
  /* Adjusted size of the arrow */
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
}

.bar {
  width: 18px;
  /* Adjusted width */
  height: 2px;
  /* Adjusted height */
  background-color: #2196f3;
  margin: 0 auto;
}



@keyframes downloading {
  0% {
    top: 0;
    opacity: 1;
  }

  50% {
    top: 110%;
    opacity: 0;
  }

  52% {
    top: -110%;
    opacity: 0;
  }

  100% {
    top: 0;
    opacity: 1;
  }
}
</style>
